import type { ViewStyle } from "react-native";

import { ZIndexToken } from "@/ui/theme/tokens";

const ToastGap = 60;
const BaseTopPadding = 8;
const getToastsPositionStyle = ({
  index,
  topSafeAreaInset,
  total,
}: {
  index: number;
  topSafeAreaInset: number;
  total: number;
}): ViewStyle => {
  if (total === 0) return {};

  const verticalOffset = topSafeAreaInset + BaseTopPadding + index * ToastGap;
  return {
    left: "auto",
    right: "auto",
    top: verticalOffset,
    zIndex: ZIndexToken.Toast,
  };
};

export { getToastsPositionStyle };
